(() => {
	/**
	 * Icon Card — mobile accordion.
	 *
	 * Below the large breakpoint the comp shows only the icon and title, with the
	 * description behind a chevron; from there up everything is visible and the
	 * chevron is gone (CSS hides it, so it can't be reached by a click either).
	 *
	 * The collapse itself is CSS — `[aria-expanded]` on the button drives it via
	 * `data-open` on the card — so a card renders correctly with JS unavailable
	 * (open, exactly as on desktop) rather than sealed shut.
	 */
	const BREAKPOINT = 992;

	document.querySelectorAll('.block-icon-card').forEach((card) => {
		const toggle = card.querySelector('.block-icon-card__toggle');
		const head = card.querySelector('.block-icon-card__head');
		if (!toggle) return;

		// A card that's a slide stays open at every size -- the comp's mobile
		// track shows a whole card, not a collapsed row -- so it keeps neither
		// the chevron (hidden in CSS) nor the tap-to-toggle head.
		if (card.closest('.block-slider')) return;

		// Name the control after the card it belongs to, so a screen reader
		// running the list of buttons doesn't hear "Toggle description" nine
		// times over.
		const title = card.querySelector('.block-icon-card__title');
		if (title && title.textContent.trim()) {
			toggle.setAttribute('aria-label', `${toggle.getAttribute('aria-label')}: ${title.textContent.trim()}`);
		}

		const setOpen = (open) => {
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			card.dataset.open = open ? 'true' : 'false';
		};

		setOpen(false);

		toggle.addEventListener('click', () => {
			setOpen(toggle.getAttribute('aria-expanded') !== 'true');
		});

		// The whole title row is the tap target on mobile, which is what the
		// comp's full-width card implies. Guarded on width so a desktop click on
		// the heading (e.g. to select text) doesn't fire a hidden toggle.
		if (head) {
			head.addEventListener('click', (event) => {
				if (window.innerWidth >= BREAKPOINT) return;
				if (event.target.closest('a')) return;
				setOpen(toggle.getAttribute('aria-expanded') !== 'true');
			});
		}
	});
})();
